// extracted by mini-css-extract-plugin
export default {"backdrop":"Loader_backdrop__rVMoE"};